/**
 * Utilitaire pour formater les montants en devises
 */

export const getCurrencySymbol = (currency) => {
  const symbols = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
    'JPY': '¥',
    'CHF': 'CHF',
    'CAD': 'C$',
    'AUD': 'A$',
  };
  return symbols[currency] || currency;
};

/**
 * Formate une valeur monétaire avec devise et nombre de décimales
 * @param {number} value - Valeur à formater
 * @param {string} currency - Code devise (EUR, USD, etc.)
 * @param {number} decimals - Nombre de décimales (défaut: 2)
 * @returns {string} Valeur formatée (ex: "1 234,56 €")
 */
export const formatCurrency = (value, currency = 'EUR', decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) return '-';
  
  const formatted = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
  
  const symbol = getCurrencySymbol(currency);
  return `${formatted} ${symbol}`;
};

/**
 * Formate une valeur monétaire en format européen avec espaces pour les milliers
 * @param {number} value - Valeur à formater
 * @param {string} currency - Code devise
 * @param {number} decimals - Nombre de décimales
 * @param {boolean} isPercent - Si true, formate en pourcentage
 * @returns {string} Valeur formatée (ex: "1 234,56 €" ou "(1 234,56 €)" pour négatif)
 */
export const formatEuropeanCurrency = (value, currency = 'EUR', decimals = 2, isPercent = false) => {
  if (value === null || value === undefined || isNaN(value)) {
    return "0";
  }
  
  if (isPercent) {
    if (value < 0) {
      return `(${Math.abs(value).toFixed(decimals)}%)`;
    } else {
      return `${value.toFixed(decimals)}%`;
    }
  } else {
    const valueInt = Math.round(value * (10 ** decimals)) / (10 ** decimals);
    const symbol = getCurrencySymbol(currency);
    
    if (valueInt < 0) {
      return `(${Math.abs(valueInt).toLocaleString('fr-FR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })})${symbol}`;
    } else {
      return `${valueInt.toLocaleString('fr-FR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}${symbol}`;
    }
  }
};

